import { render, staticRenderFns } from "./PhysicianList.vue?vue&type=template&id=912ba9dc&scoped=true&"
import script from "./PhysicianList.vue?vue&type=script&lang=js&"
export * from "./PhysicianList.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianList.vue?vue&type=style&index=0&id=912ba9dc&lang=scss&scoped=true&"
import style1 from "./PhysicianList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ba9dc",
  null
  
)

export default component.exports